import { render, staticRenderFns } from "./ProductPP.vue?vue&type=template&id=ea1aeacc&scoped=true&"
import script from "./ProductPP.vue?vue&type=script&lang=js&"
export * from "./ProductPP.vue?vue&type=script&lang=js&"
import style0 from "./ProductPP.vue?vue&type=style&index=0&id=ea1aeacc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea1aeacc",
  null
  
)

export default component.exports